import { theme } from '@otter-ai/den-tokens';
import { defineConfig } from 'cva';
import { extendTailwindMerge } from 'tailwind-merge';

export type {
  Compose,
  CVA,
  CXOptions,
  CXReturn,
  DefineConfig,
  DefineConfigOptions,
  VariantProps,
} from 'cva';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-weight': Object.keys(theme.fontWeight).map((key) => `font-${key}`),
    },
  },
});

// See https://beta.cva.style/getting-started/installation/#handling-style-conflicts
export const {
  cva,
  cx,
  compose: composeVariants,
} = defineConfig({
  hooks: {
    onComplete: (className) => twMerge(className),
  },
});
